import React, { useState, useEffect, useRef } from 'react';
import { get, post, put } from '../services/apiController';
import { DEBOUNCE_DELAY, TABLE_DEFAULT_LIMIT } from '../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from './icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import { states } from '../util/constant';
import useDebounce from './useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import Breadcrumb from '../components/Breadcrumb';
import { getStoredData, get_auth_key } from '../util';

const VendorMaster = () => {
  const formFields = { name: '', gst_num: '', address: '', contact_num: '', email: '', city: '', pincode: '', state: '', country: 'IND' };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [venderMasterForm, setVenderMasterForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  // const [idToDeleted, setIdToDeleted] = useState("");
  // const [deleteModel, setDeleteModel] = useState(false);
  const [venderMasterList, setVenderMasterList] = useState([]);
  const [query, setQuery] = useState('');
  const clickToDownload = useRef(null);
  const storedData = JSON.parse(getStoredData(get_auth_key()));

  const handleShow = () => {
    setShowConfirmModel(true);
    setVenderMasterForm(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    try {
      get('/vendor-masters/?id=' + id).then((res) => {
        if (res.data.rows.length) {
          const Data = res.data.rows[0];
          setVenderMasterForm(Data);
          setShowConfirmModel(true);
        } else {
          toast.error('No Vendor found with this name');
        }
      });
    } catch (error) {
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setVenderMasterForm({ ...venderMasterForm, [name]: value });
  };

  // const handleRemove = (event, id) => {
  //   event.preventDefault();
  //   try {
  //     destroy('/vendor-masters/' + id).then(response => {
  //       toast.success("Vendor Deleted successfully");
  //       setDeleteModel(false);
  //       getVendors();
  //     })
  //   }
  //   catch (err) {
  //     toast.error(err.message, { autoClose: 2000 });
  //   }
  // }

  // const handleConfirmDeleteModal = (e, id) => {
  //   e.preventDefault();
  //   setDeleteModel(true);
  //   setIdToDeleted(id);
  // }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in venderMasterForm) {
      try {
        await put(venderMasterForm, '/vendor-masters/' + venderMasterForm.id);
        toast.success('Vendor updated successfully');
        setShowConfirmModel(false);
        getVendors();
      } catch (err) {
        toast.error(err.response.data.message || err.message, { autoClose: 3000 });
      }
    } else {
      try {
        await post(venderMasterForm, '/vendor-masters/');
        toast.success('Vendor created successfully');
        setShowConfirmModel(false);
        getVendors();
      } catch (err) {
        toast.error(err.response.data.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getVendors() {
    try {
      get(`/vendor-masters/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}`).then((response) => {
        setVenderMasterList(response.data.rows);
        setTotalRecords(response.data.count);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'Something went wrong');
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getVendors();
      }
    },
    [query],
    DEBOUNCE_DELAY
  );

  function excelReport() {
    try {
      get(`/vendor-masters/?conditionType=download`).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useEffect(() => {
    getVendors();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Settings' },
          { link: '#', title: 'Vendors' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Vendors | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by vendor name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <GrDocumentExcel title="Download vendors" className="react-icons green" onClick={excelReport} />
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
            <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
              Add
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>GST No.</th>
                    <th>Contact Number</th>
                    <th>Email</th>
                    {storedData.role === 'super-admin' && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {venderMasterList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item?.name}</td>
                        <td>{item?.gst_num}</td>
                        <td>{item?.contact_num}</td>
                        <td>{item?.email}</td>
                        {storedData.role === 'super-admin' && (
                          <td className="actions">
                            <span onClick={(e) => handleEdit(e, item?.id)} className="edit-icon">
                              <EditIcon style={{ color: 'teal' }} />
                            </span>
                            {/* <Link onClick={(e) => handleConfirmDeleteModal(e, item?.id)} className="delete" ><DeleteIcon /></Link> */}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in venderMasterForm ? 'Edit Vendor' : 'Add Vendor'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSubmit}>
            <Row>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Vendor Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="name"
                    value={venderMasterForm.name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Vendor Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Vendor GST" className="mb-3">
                  <Form.Control
                    className="input"
                    name="gst_num"
                    value={venderMasterForm.gst_num}
                    onChange={handleChange}
                    type="text"
                    placeholder="Vendor GST"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Vendor Address" className="mb-3">
                  <Form.Control
                    className="input"
                    name="address"
                    value={venderMasterForm.address}
                    onChange={handleChange}
                    type="text"
                    placeholder="Vendor Address"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6} lg={6}>
                <FloatingLabel controlId="floatingInput" label="Vendor Contact" className="mb-3">
                  <Form.Control
                    className="input"
                    name="contact_num"
                    value={venderMasterForm.contact_num}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && value >= 0) {
                        handleChange(e);
                      }
                    }}
                    type="text"
                    placeholder="Vendor Contact"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6} lg={6}>
                <FloatingLabel controlId="floatingInput" label="Vendor Email" className="mb-3">
                  <Form.Control
                    className="input"
                    name="email"
                    value={venderMasterForm.email}
                    onChange={handleChange}
                    type="text"
                    placeholder="Vendor Email"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6} lg={6}>
                <FloatingLabel controlId="floatingInput" label="City" className="mb-3">
                  <Form.Control
                    className="input"
                    name="city"
                    value={venderMasterForm.city}
                    onChange={handleChange}
                    type="text"
                    placeholder="City"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6} lg={6}>
                <FloatingLabel controlId="floatingInput" label="Pincode" className="mb-3">
                  <Form.Control
                    className="input"
                    name="pincode"
                    value={venderMasterForm.pincode}
                    onChange={handleChange}
                    type="text"
                    placeholder="Pincode"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6} lg={6}>
                <FloatingLabel controlId="floatingInput" label="State" className="mb-3">
                  <Form.Select className="input" value={venderMasterForm?.state} name="state" onChange={handleChange}>
                    <option value="">Select State</option>
                    {states.map((item) => {
                      return (
                        <option key={item?.value} value={item?.value}>
                          {item?.label}
                        </option>
                      );
                    })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={6} lg={6}>
                <FloatingLabel controlId="floatingInput" label="Country" className="mb-3">
                  <Form.Select className="input" value={venderMasterForm?.country} name="country" onChange={handleChange}>
                    <option value="">Select Country</option>
                    <option value="IND">India</option>
                    <option value="OTH">Other</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={12}>
                <Button type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                  {'id' in venderMasterForm ? 'Update' : 'Add'}
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {/* <Modal
        size="sm"
        show={deleteModel}
        backdrop="static"
        keyboard={false}
        className="request-modal"
      >
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="alert icon" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={() => setDeleteModel(false)} className="btn app-btn-default btn-sm">Cancel</button>
            <button onClick={(event) => handleRemove(event, idToDeleted)} className="btn app-btn-danger btn-sm">Delete</button>
          </div>
        </Modal.Footer>
      </Modal> */}
    </React.Fragment>
  );
};

export default VendorMaster;
